import { mapState } from "../store/map";
import { linearColorWordCloud } from "../utils/word-cloud";
import { computed } from "@vue/runtime-core";
export default {
  name: "KilaKilaTagCard",
  setup: function setup() {
    var _mapState = mapState("tagAbout"),
        tagCounts = _mapState.tagCounts;

    var tagClouds = computed(function () {
      return linearColorWordCloud(tagCounts.value);
    });
    return {
      tagClouds: tagClouds
    };
  }
};